.atm_mk_h2mmj6{position:relative;}
.atm_r2_1j28jx2{-webkit-tap-highlight-color:transparent;}
.atm_2d_1j28jx2.atm_2d_1j28jx2{background-color:transparent;}
.atm_kd_idpfg4{outline:0;}
.atm_3f_idpfg4{border:0;}
.atm_gi_idpfg4{margin:0;}
.atm_5j_idpfg4{border-radius:0;}
.atm_l8_idpfg4{padding:0;}
.atm_9j_tlke0l{cursor:pointer;}
.atm_vb_glywfm{user-select:none;}
.atm_1s_glywfm{appearance:none;}
.atm_1lhom2b_glywfm.atm_1lhom2b_glywfm::-moz-focus-inner{border-style:none;}
.atm_17yrrpa_glywfm:focus-visible{outline:none;}
.atm_rd_glywfm{text-decoration:none;}
.atm_pgg0nz_glywfm:hover{text-decoration:none;}
.atm_mj_glywfm{pointer-events:none;}
.atm_9j_73adwj{cursor:default;}
.atm_15t0my6_glywfm:hover,.atm_15t0my6_glywfm:focus{outline:none;}
.atm_1g26zs6_8stvzk:hover,.atm_1g26zs6_8stvzk:focus{text-decoration:underline;}
